import React, { useEffect, useState } from 'react';
import { CCarousel, CCarouselItem, CImage } from '@coreui/react';
import '@coreui/coreui/dist/css/coreui.min.css';
import Carrusel01Img from "../images/Carrusel01.jpg";
import Carrusel02Img from "../images/Carrusel02.jpg";
import Carrusel03Img from "../images/Carrusel03.jpg";

const Carousel = () => {
  const carouselStyle = {
    width: '100%',
    overflow: 'hidden' 
  };

  const getImageStyle = () => {
    const isMobile = window.innerWidth < 768;
    return {
      objectFit: 'cover',
      width: isMobile ? '100%' : '80%',
      height: isMobile ? '400px' : '700px',
      display: 'block',
      margin: '0 auto',
    };
  };

  const [imageStyle, setImageStyle] = useState(getImageStyle());

  useEffect(() => {
    const handleResize = () => {
      setImageStyle(getImageStyle());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={carouselStyle}>
      <CCarousel controls indicators dark>
        <CCarouselItem>
          <CImage
            style={imageStyle}
            src={Carrusel02Img}
            alt="Anestecsiólogo"
          />
        </CCarouselItem>

        <CCarouselItem>
          <CImage
            style={imageStyle}
            src={Carrusel03Img}
            alt="Cirugia"
          />
        </CCarouselItem>

        <CCarouselItem>
          <CImage
            style={imageStyle}
            src={Carrusel01Img}
            alt="Doctor revisando"
          />
        </CCarouselItem>
      </CCarousel>
    </div>
  );
};

export default Carousel;
